import React from 'react';
import moment from "moment";
import Link from '../base/Link';
import API from "../base/API";
import Auth from "../auth/Auth";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import { translate } from '../base/Translation';
import Storage from "../base/Storage";

export default class ClientList extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_clients: "/client/fetch/all?limit_from=:from&limit_max=:to&brand=:brand",
			delete_client: "/client/delete/:client"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			clients: [],
			tableData: [],
			tableColumns: [
				{ name: "name", display: translate("Názov"), sort: true, width: 65 },
				{ name: "brand", display: translate("Značka"), sort: true, width: 14 },
				{ name: "date_created", display: translate("Vytvorené"), sort: true, width: 9 },
				{ name: "date_updated", display: translate("Upravené"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 3 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (client) {
			let data = {};
			data.id = client.id;
			data.name = <Link to={"/clients/edit/" + client.id}>{client.name}</Link>;
			data.brand = client.brand;
			data.date_created = moment(client.created.date).format("D.M.Y");
			data.date_updated = moment(client.updated.date).format("D.M.Y");
			data.options = <DeleteButton onClick={this.onDelete.bind({ client: client.id, currentComponent: this })} permission="ClientNew" />;
			return data;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");

		this.api.request({
			cache: true,
			route: "get_clients",
			params: { from: this.state.limit_from, to: this.state.limit_to, brand: (brandFilter ? brandFilter.id : "all") },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ clients: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onDelete(evt) {
		this.currentComponent.api.request({
			route: "delete_client",
			params: { client: this.client },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Klienti")} right={() => {
				return (
					<Link to="/clients/add/new"
						permission="ClientNew"
						className="btn btn-success btn-sm pull-right">
						<i className="fa fa-plus" /> {translate("Pridať")}
					</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/client/ClientList.js